import { render, staticRenderFns } from "./MesaObrasGenericPaseNewOrEdit.vue?vue&type=template&id=6fc459c8&scoped=true&"
import script from "./MesaObrasGenericPaseNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./MesaObrasGenericPaseNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./MesaObrasGenericPaseNewOrEdit.vue?vue&type=style&index=0&id=6fc459c8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc459c8",
  null
  
)

export default component.exports